import { getIframeAndValidatePaymentApiRoute } from "@api-routes/eirStancerFacade";
import { getIframeAndValidatePaymentApiRoute as getElavonIframeAndValidatePaymentApiRoute } from "@api-routes/elavonFacade";
import { StancerPaymentIframe } from "@common/PaymentIframe/stancer/payment/StancerPaymentIframe";
import { ElavonPaymentIframe } from "@common/PaymentIframe/elavon/ElavonPaymentIframe";

interface IParams {
    isNewPaymentProvider: boolean;
    successCallback(): void;
}

export const NoAuthPaymentIframe = (props: IParams) => {
    const { isNewPaymentProvider, successCallback } = props;

    if (!isNewPaymentProvider) {
        return (
            <ElavonPaymentIframe
                iframePaymentApiRoute={getElavonIframeAndValidatePaymentApiRoute()}
                successCallback={successCallback}
                validatePaymentApiRoute={getElavonIframeAndValidatePaymentApiRoute()}
            />
        );
    }

    return (
        <StancerPaymentIframe
            iframePaymentApiRoute={getIframeAndValidatePaymentApiRoute()}
            successCallback={successCallback}
            validatePaymentApiRoute={getIframeAndValidatePaymentApiRoute()}
        />
    );
};
